import React, { useState, useEffect } from "react";
import Typing from "react-typing-animation";
import { PropagateLoader } from "react-spinners";

import my__image from "../../assets/vaibhav.png";
import Particle from "../../Components/Particle";
import "./About.css";
import "../../loadingStyle.css";

export default function About() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 850);
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loading">
          <PropagateLoader color="#F9880D" loading={loading} size={15} />
        </div>
      ) : (
        <div>
          <Particle />
          <div className="about__content">
            <div className="about__content__heading">
              <Typing
                cursorClassName="custom"
                cursor={<span>_</span>}
                speed={80}
              >
                <h1>About me</h1>
              </Typing>
            </div>
            <div className="about__content__content">
              <p>
                I'm presently a Software Engineer, proficient in full stack web 
                development.
              </p>
              <p>
                Passionate about problem-solving,
                I love spending time on fixing
                little details and optimizing web apps.
              </p>
              <p>
                Open to open source contributions or project collaborations. 
                Feel free to approach me with any such opportunities.
              </p>
            </div>
          </div>
          <div className="About__image">
            <img alt="my ppf" src={my__image} height="300" width="300" />
          </div>
        </div>
      )}
    </div>
  );
}
